import { Component } from '@theme/component';

class HeroPromoCopy extends Component {
  #resetTimeout;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);

    if (this.#resetTimeout) {
      window.clearTimeout(this.#resetTimeout);
    }
  }

  #handleClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('button') : null;

    if (!(button instanceof HTMLButtonElement)) return;

    const text = this.getAttribute('text-to-copy');

    if (!text) return;

    try {
      await this.#copyText(text);
      this.#showCopiedState();
    } catch (error) {
      console.error('Failed to copy hero promo code', error);
    }
  };

  async #copyText(text) {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    input.style.pointerEvents = 'none';

    document.body.append(input);
    input.select();
    input.setSelectionRange(0, input.value.length);

    const copied = document.execCommand('copy');
    input.remove();

    if (!copied) {
      throw new Error('Clipboard API unavailable');
    }
  }

  #showCopiedState() {
    this.setAttribute('data-copied', 'true');

    if (this.refs.liveRegion instanceof HTMLElement) {
      this.refs.liveRegion.textContent = this.refs.liveRegion.dataset.successMessage || '';
    }

    if (this.#resetTimeout) {
      window.clearTimeout(this.#resetTimeout);
    }

    this.#resetTimeout = window.setTimeout(() => {
      this.removeAttribute('data-copied');

      if (this.refs.liveRegion instanceof HTMLElement) {
        this.refs.liveRegion.textContent = '';
      }
    }, 2200);
  }
}

if (!customElements.get('hero-promo-copy')) {
  customElements.define('hero-promo-copy', HeroPromoCopy);
}
